export const PARTY_COLORS = {
  'Andere-links': '#BF3939', // links
  SP: '#F0554D', // SP
  Grüne: '#84B547', // GPS
  EVP: '#DEAA28', // EVP
  GLP: '#C4C43D', // GLP
  BDP: '#E6C820', // BDP
  EAG: '#ad4f89',
  SOL: '#AD3434',
  andere: '#B8B8B8', // andere
  Andere: '#B8B8B8', // andere
  'Andere-mitte': '#B8B8B8', // andere Mitte
  PdA: '#BF3939', // andere
  Parteilos: '#B8B8B8', // andere
  CVP: '#D6862B', // CVP
  FDP: '#3872B5', // FDP
  LDP: '#618DEA', // FDP
  MCG: '#A65E42', // rechts,
  Lega: '#9070D4', // Lega
  EDU: '#A65E42',
  SVP: '#4B8A3E', // SVP
  'Andere-rechts': '#A65E42' // rechts
}
